import { useTranslation } from 'react-i18next';
import { AppLocale, LOCALE_STORAGE_KEY, syncBodyLocaleClass } from './index';

export function useLocale() {
  const { i18n } = useTranslation();
  const locale = i18n.language as AppLocale;

  const setLocale = (next: AppLocale) => {
    if (next === locale) {
      return;
    }
    if (typeof window === 'undefined') {
      void i18n.changeLanguage(next);
      return;
    }
    syncBodyLocaleClass(next);
    window.localStorage.setItem(LOCALE_STORAGE_KEY, next);
    // URL 上的 lng 参数优先级高于 localStorage，若存在需同步更新，避免刷新后被旧值覆盖导致切换无效
    const url = new URL(window.location.href);
    if (url.searchParams.has('lng')) {
      url.searchParams.set('lng', next);
      window.history.replaceState(null, '', url.toString());
    }
    // 整页刷新：部分文案来自模块级静态常量（在模块加载时通过 i18next.t() 求值并固化），
    // 软切换 changeLanguage 无法让其重算，必须重新加载页面以按新语言重新初始化这些常量。
    window.location.reload();
  };

  return { locale, setLocale };
}
